import React from "react";

function bookHtml() {
  return (
    <div style={{fontSize: '1.2em'}}>
      <div style={{marginBottom: '10px'}}>This companion book includes:</div>
      <ul>
        <li>Illustrated lesson notes</li>
        <li>Lesson worksheets</li>
        <li>Practice exercises</li>
        <li>Review worksheets</li>
        <li>Suggested pacing guide</li>
        <li>Formula and resource worksheets</li>
      </ul>
    </div>
  );
}

const scriptUrl = "https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=";
const bookHost = "https://online.flippingbook.com/view/";
const productHost = "https://www.thinkwellhomeschool.com/products/";

export default {
  AL1_SUB_FULL: {
    1: {
      title: "Algebra 1 Companion Book, Chapters 1 - 5",
      productUrl: productHost + "algebra-1-companion-book-volume-1",
      bookUrl: bookHost + "564708722",
      scriptUrl: scriptUrl + "564708722",
      fboId: "9e622af6e0",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 1 Companion Book, Chapters 6 - 10",
      productUrl: productHost + "algebra-1-companion-book-volume-2",
      bookUrl: bookHost + "1025986392",
      scriptUrl: scriptUrl + "1025986392",
      fboId: "95b2fa48a1",
      html: bookHtml,
      volume: 2
    }
  },
  AL2_SUB_FULL: {
    1: {
      title: "Algebra 2 Companion Book, Chapters 1 - 5",
      productUrl: productHost + "algebra-2-companion-book-volume-1",
      bookUrl: bookHost + "570364034",
      scriptUrl: scriptUrl + "570364034",
      fboId: "9b90090fd2",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 2 Companion Book, Chapters 6 - 9",
      productUrl: productHost + "algebra-2-companion-book-volume-2",
      bookUrl: bookHost + "805582676",
      scriptUrl: scriptUrl + "805582676",
      fboId: "6dcd66e003",
      html: bookHtml,
      volume: 2
    }
  },
  GEO_SUB_FULL: {
    1: {
      title: "Geometry Companion Book, Chapters 1 - 5",
      productUrl: productHost + "geometry-companion-book-volume-1",
      bookUrl: bookHost + "406820671",
      scriptUrl: scriptUrl + "406820671",
      fboId: "b94b908558",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Geometry Companion Book, Chapters 6 - 10",
      productUrl: productHost + "geometry-companion-book-volume-2",
      bookUrl: bookHost + "406169011",
      scriptUrl: scriptUrl + "406169011",
      fboId: "283168f1dd",
      html: bookHtml,
      volume: 2
    }
  },
  AL1H_SUB_FULL: {
    1: {
      title: "Honors Algebra 1 Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-algebra-1-companion-book-volume-1",
      bookUrl: bookHost + "420765151",
      scriptUrl: scriptUrl + "420765151",
      fboId: "02a17ab319",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Algebra 1 Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-algebra-1-companion-book-volume-2",
      bookUrl: bookHost + "420735026",
      scriptUrl: scriptUrl + "420735026",
      fboId: "d59f67844d",
      html: bookHtml,
      volume: 2
    }
  },
  AL2H_SUB_FULL: {
    1: {
      title: "Honors Algebra 2 Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-algebra-2-companion-book-volume-1",
      bookUrl: bookHost + "406061530",
      scriptUrl: scriptUrl + "406061530",
      fboId: "24de236a17",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Algebra 2 Companion Book, Chapters 7 - 14",
      productUrl: productHost + "honors-algebra-2-companion-book-volume-2",
      bookUrl: bookHost + "406488699",
      scriptUrl: scriptUrl + "406488699",
      fboId: "d30352fae2",
      html: bookHtml,
      volume: 2
    }
  },
  GEOH_SUB_FULL: {
    1: {
      title: "Honors Geometry Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-geometry-companion-book-volume-1",
      bookUrl: bookHost + "25050817",
      scriptUrl: scriptUrl + "25050817",
      fboId: "953ec4eaf9",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Geometry Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-geometry-companion-book-volume-2",
      bookUrl: bookHost + "24403033",
      scriptUrl: scriptUrl + "24403033",
      fboId: "f8ffed8d68",
      html: bookHtml,
      volume: 2
    }
  },
  AL1R_SUB_FULL: {
    1: {
      title: "Algebra 1 Readiness",
      productUrl: productHost + "algebra-1-readiness-study-guide",
      bookUrl: bookHost + "882863563",
      scriptUrl: scriptUrl + "882863563",
      fboId: "a9882a29ea",
      html: bookHtml,
      volume: 1
    }
  },
  AL1S_SUB_FULL: {
    1: {
      title: "Algebra 1 Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "457810565",
      scriptUrl: scriptUrl + "457810565",
      fboId: "fd331a8415",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 1 Summer Edition Companion Book, Chapters 6 - 10",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "817791474",
      scriptUrl: scriptUrl + "817791474",
      fboId: "a7b03e9acb",
      html: bookHtml,
      volume: 2
    }
  },
  AL2S_SUB_FULL: {
    1: {
      title: "Algebra 2 Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "898466145",
      scriptUrl: scriptUrl + "898466145",
      fboId: "5f3dc4b5a6",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Algebra 2 Summer Edition Companion Book, Chapters 6 - 9",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "898181195",
      scriptUrl: scriptUrl + "898181195",
      fboId: "b84cec3838",
      html: bookHtml,
      volume: 2
    }
  },
  GEOS_SUB_FULL: {
    1: {
      title: "Geometry Summer Edition Companion Book, Chapters 1 - 5",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "1057265548",
      scriptUrl: scriptUrl + "1057265548",
      fboId: "3ccccfcae8",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Geometry Summer Edition Companion Book, Chapters 6 - 12",
      productUrl: "https://www.thinkwellhomeschool.com/",
      bookUrl: bookHost + "1057022609",
      scriptUrl: scriptUrl + "1057022609",
      fboId: "5e5dbafc06",
      html: bookHtml,
      volume: 2
    }
  },
  G6M_SUB_FULL: {
    1: {
      title: "6th Grade Math Companion Book, Chapters 1 - 5",
      productUrl: productHost + "grade-6th-math-companion-book-volume-1",
      bookUrl: bookHost + "372250673",
      scriptUrl: scriptUrl + "372250673",
      fboId: "291ecccb15",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "6th Grade Math Companion Book, Chapters 6 - 11",
      productUrl: productHost + "grade-6-math-companion-book-volume-2",
      bookUrl: bookHost + "372309000",
      scriptUrl: scriptUrl + "372309000",
      fboId: "513b5957c8",
      html: bookHtml,
      volume: 2
    }
  },
  G6MH_SUB_FULL: {
    1: {
      title: "Honors 6th Grade Math Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-grade-6th-math-companion-book-volume-1",
      bookUrl: bookHost + "930043383",
      scriptUrl: scriptUrl + "930043383",
      fboId: "a58c8ba350",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors 6th Grade Math Companion Book, Chapters 7 - 13",
      productUrl: productHost + "honors-grade-6-math-companion-book-volume-2",
      bookUrl: bookHost + "372975358",
      scriptUrl: scriptUrl + "372975358",
      fboId: "76c97e151c",
      html: bookHtml,
      volume: 2
    }
  },
  G7M_SUB_FULL: {
    1: {
      title: "7th Grade Math Companion Book, Chapters 1 - 5",
      productUrl: productHost + "7th-grade-math-companion-book-volume-1",
      bookUrl: bookHost + "437147512",
      scriptUrl: scriptUrl + "437147512",
      fboId: "e414ba479a",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "7th Grade Math Companion Book, Chapters 6 - 10",
      productUrl: productHost + "7th-grade-math-companion-book-volume-2",
      bookUrl: bookHost + "436366454",
      scriptUrl: scriptUrl + "436366454",
      fboId: "18f5ad8102",
      html: bookHtml,
      volume: 2
    }
  },
  G7MH_SUB_FULL: {
    1: {
      title: "Honors 7th Grade Math Companion Book, Chapters 1 - 6",
      productUrl: productHost + "honors-7th-grade-math-companion-book-volume-1",
      bookUrl: bookHost + "168794635",
      scriptUrl: scriptUrl + "168794635",
      fboId: "96b6fcbacb",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors 7th Grade Math Companion Book, Chapters 7 - 12",
      productUrl: productHost + "honors-7th-grade-math-companion-book-volume-2",
      bookUrl: bookHost + "168776249",
      scriptUrl: scriptUrl + "168776249",
      fboId: "1ded7595b3",
      html: bookHtml,
      volume: 2
    }
  },
  G8M_SUB_FULL: {
    1: {
      title: "Prealgebra (8th Grade Math) Companion Book, Chapters 1 - 6",
      productUrl: productHost + "prealgebra-companion-book-vol-1",
      bookUrl: bookHost + "710186708",
      scriptUrl: scriptUrl + "710186708",
      fboId: "074585e219",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Prealgebra (8th Grade Math) Companion Book, Chapters 7 - 11",
      productUrl: productHost + "prealgebra-companion-book-vol2",
      bookUrl: bookHost + "710291066",
      scriptUrl: scriptUrl + "710291066",
      fboId: "df3af1d79c",
      html: bookHtml,
      volume: 2
    }
  },
  G8MH_SUB_FULL: {
    1: {
      title: "Honors Prealgebra (8th Grade Math) Companion Book, Chapters 1 - 7",
      productUrl: productHost + "honors-prealgebra-companion-book-volume-1",
      bookUrl: bookHost + "517566191",
      scriptUrl: scriptUrl + "517566191",
      fboId: "e9e74d8acd",
      html: bookHtml,
      volume: 1
    },
    2: {
      title: "Honors Prealgebra (8th Grade Math) Companion Book, Chapters 8 - 14",
      productUrl: productHost + "honors-prealgebra-companion-book-volume-2",
      bookUrl: bookHost + "9510167",
      scriptUrl: scriptUrl + "9510167",
      fboId: "7465508de0",
      html: bookHtml,
      volume: 2
    }
  }
};
